import { supabase } from "../lib/supabaseClient";

export default async function SendEmail({
  email,
  ccEmails,
  subject,
  message,
  attachments,
  storageBucket,
}) {
  const session = await supabase.auth.getSession();
  const accessToken = session.data?.session?.access_token;

  const payload = {
    email,
    subject,
    message,
    ccEmails: ccEmails || [],
    attachments: attachments || [],
    storageBucket: storageBucket || "",
  };

  const response = await fetch(
    "https://hupnidxelbhaluxrsygd.supabase.co/functions/v1/bright-processor",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload),
    }
  );
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Email send failed");
  }
  return data;
}
